import React from 'react'
import { RecommenderSettingsForm } from '../RecommenderSettingsForm/RecommenderSettingsForm'
import { RecommenderSettings } from '@/api/types'
import { Button } from '@/components/Button'

export default function RecommenderSettingsEditor({
  recommenderSettings,
  setRecommenderSettings,
  resetRecommenderSettings,
}: {
  recommenderSettings: RecommenderSettings
  setRecommenderSettings: (settings: RecommenderSettings) => void
  resetRecommenderSettings: () => void
}) {
  return (
    <div>
      <RecommenderSettingsForm
        recommenderSettings={recommenderSettings}
        setRecommenderSettings={setRecommenderSettings}
        style={{ padding: '20px 0' }}
      />
      <Button onPress={resetRecommenderSettings}>Reset to default</Button>
    </div>
  )
}
